<script setup>
import { RouterView, RouterLink } from 'vue-router'
import { ArrowLeftIcon } from '@heroicons/vue/24/outline'
</script>

<template>
  <div class="min-h-screen relative">
    <!-- Back to site button -->
    <RouterLink
      to="/"
      class="absolute top-4 left-4 z-10 flex items-center gap-2 text-gray-600 hover:text-primary-600 transition-colors bg-white/80 backdrop-blur-sm px-3 py-2 rounded-lg shadow-sm"
    >
      <ArrowLeftIcon class="w-5 h-5" />
      <span class="text-sm font-medium">Voltar ao site</span>
    </RouterLink>

    <RouterView />
  </div>
</template>
